module.exports = __webpack_public_path__ + "static/img/register-vendor-header.0fe7a7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/register-vendor-header.png
// module id = zImv
// module chunks = 0